import posthog, { CaptureOptions, EventName, Properties } from "posthog-js";

export function trackEventPosthog(
	event_name: EventName,
	properties?: Properties | null,
	options?: CaptureOptions
) {
	return posthog?.capture(event_name, properties, options);
}
